export default "__VITE_ASSET__02xHU9g7__"